import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import WhyUs from "@/components/site/WhyUs";
import Reviews from "@/components/site/Reviews";
import Visit from "@/components/site/Visit";
import Footer from "@/components/site/Footer";
import FloatingCall from "@/components/site/FloatingCall";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="bg-[#FAFAF9] min-h-screen">
      <Header />
      <Hero />
      <About />
      <Services />
      <WhyUs />
      <Reviews />
      <Visit />
      <Footer />
      <FloatingCall />
    </main>
  );
}
